import React, { useState } from 'react';
import './login.css';
import '../root.css'

const Login = () => {
  const [email, setEmail] = useState('admin@spine.com');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
  
    setTimeout(() => {
      if (email === 'admin@spine.com' && password === 'SpineAdmin2026!') {
        localStorage.setItem('isAdminLoggedIn', 'true');
        window.location.href = '/home';
      } else {
        setError('Invalid email or password');
      }
  
      setLoading(false);
    }, 600);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="book-icon">♡</div>
          <h1>Spine Admin</h1>
          <p>Literary Events Platform</p>
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          <h2>Welcome Back</h2>

          {error && <div className="login-error">{error}</div>}

          <label>Email Address</label>
          <div className="input-box">
            <span>✉</span>
            <input
              type="email"
              placeholder="admin@spine.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <label>Password</label>
          <div className="input-box">
            <span>🔒</span>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="eye-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              👁
            </button>
          </div>

          <div className="login-options">
            <label className="remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={() => setRemember(!remember)}
              />
              Remember me
            </label>
            <button type="button" className="forgot-btn">
              Forgot password?
            </button>
          </div>

          <button className="sign-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          <p className="secure-text">
            Secure admin access for Spine Literary Events
          </p>
        </form>
      </div>

      <div className="quote">
        <p>"A room without books is like a body without a soul."</p>
        <span>— Marcus Tullius Cicero</span>
      </div>
    </div>
  );
};

export default Login;